import { atom, selector } from 'recoil';

export const countState = atom({
    key: 'countSt', 
    default: 0,
});

export const netPriceState = atom({
    key: 'netPriceSt',
    default: 0,
})

export const imageCountState = atom({
    key: 'imageCountSt',
    default: 0,
})

export const totalPriceState = atom({
    key: 'totalPriceSt',
    default: 0,
})

export const discountPriceState = atom({
    key: 'discountPriceSt',
    default: 0,
})

export const discountPercentageState = atom({
    key: 'discountPercentageSt',
    default: 0,
})

// New atoms for frame pricing
export const framePricesState = atom({
    key: 'framePricesSt',
    default: {
        authentic: 49,
        clean: 49,
        bold: 49,
        classic: 49,
        nordic: 49,
        village: 49
    }
})

export const defaultFramePriceState = atom({
    key: 'defaultFramePriceSt',
    default: 49
})

// Shipping price atom
export const shippingPriceState = atom({
    key: 'shippingPriceSt',
    default: 35
})

// Handling fee atom (0.36 ILS per image)
export const handlingFeeState = atom({
    key: 'handlingFeeSt',
    default: 0.36
})

// Credits applied to current cart
export const creditsAppliedState = atom({
    key: 'creditsAppliedSt',
    default: 0,
})

// User's total credits balance
export const creditsBalanceState = atom({
    key: 'creditsBalanceSt',
    default: 0,
})

// Get cached discount config from localStorage or use fallback default
const getInitialDiscountConfig = () => {
    try {
        const cached = localStorage.getItem('discountConfig');
        if (cached) {
            return JSON.parse(cached);
        }
    } catch (e) {
        // Ignore parse errors
    }
    // Fallback default (only used on very first visit)
    return {
        promotionName: '',
        emoji: '',
        colors: {
            tagBackground: '#212121',
            tagText: '#f6cd00',
            discountedPrice: '#087E63',
            bundleBadgeBackground: '#265697'
        },
        tiers: []
    };
};

// Discount configuration atom
export const discountConfigState = atom({
    key: 'discountConfigSt',
    default: getInitialDiscountConfig()
})

// Computed selector to convert tiers array to discountConfig object format
// for backward compatibility with existing code
export const discountConfigObjectState = selector({
    key: 'discountConfigObjectSt',
    get: ({get}) => {
        const config = get(discountConfigState);
        const configObj = {};

        if (config.tiers && config.tiers.length > 0) {
            config.tiers.forEach(tier => {
                configObj[tier.imageCount] = {
                    discount: tier.discount,
                    coupons: tier.coupons || [],
                    enableDefault: tier.enableDefault,
                    exactAmount: tier.exactAmount,
                    fallbackToLower: tier.fallbackToLower
                };
            });
        }

        return configObj;
    }
})
